export default "__VITE_ASSET__Dft2iEGO__"